import styled from "styled-components";
import { DialogConsumerContentDefaultBox } from "./dialog-consumer-content.default.box";

export const DialogConsumerContentMrGreenCisBox = styled(DialogConsumerContentDefaultBox)`
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
`;